import { useQuery } from "@tanstack/react-query";
import { freshnessQuery } from "@/api/queries";

export function useFreshness() {
  return useQuery(freshnessQuery());
}
